import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Prescription } from '@lyrahealth-inc/shared-app-logic/src/models/prescription/Prescription'
import { MedicationSidePanelItem } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/clientDetailsSidePanel/medications/MedicationsSidePanelSection'

import { getSelectedClientId } from '../../../../../data/lyraTherapy/clientSelectors'
import { useGetPatientPrescriptionsQuery } from '../../../../medications/data/medicationsApi'

const REQUESTED_STATUS = 8
const ACTIVE_MEDICATION_STATUS = 'Active'

const isActivePrescription = (prescription: Prescription) =>
  prescription.Status !== REQUESTED_STATUS &&
  typeof prescription.MedicationStatus === 'string' &&
  prescription.MedicationStatus.trim() === ACTIVE_MEDICATION_STATUS

export const useMedicationsSidePanelData = ({ skip }: { skip: boolean }): MedicationSidePanelItem[] => {
  const clientId = useSelector(getSelectedClientId)
  const { currentData: prescriptions } = useGetPatientPrescriptionsQuery(
    { clientId: clientId! },
    { skip: skip || !clientId },
  )

  return useMemo(
    () =>
      (prescriptions ?? [])
        .filter(isActivePrescription)
        .sort((a, b) => b.WrittenDate.localeCompare(a.WrittenDate))
        .map((prescription) => ({
          id: String(prescription.PrescriptionId),
          name: prescription.DisplayName,
          prescribedOn: prescription.WrittenDate,
          quantity: [prescription.Quantity, prescription.DispenseUnitDescription].filter(Boolean).join(' '),
          refillCount: Number(prescription.Refills) || 0,
          directions: prescription.Directions,
        })),
    [prescriptions],
  )
}
